import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Solution = () => {
    return (
        <div className="rgs-solution">
            <FullWrapper isMargin={false} className="rgs-solutionCase">
                <div className="rgs-solutionWrapper">
                    <div className="rgs-solutionTitle">Предпосылки проекта</div>
                    <div className="rgs-solutionInner">
                        <div className="rgs-solutionLeft">
                            <div className="rgs-solutionDescription">
                                На&nbsp;старте проекта была информационная система
                                с&nbsp;ограниченным функционалом и&nbsp;разрозненными подсистемами.
                                Из-за этого не&nbsp;все бизнес-процессы были синхронизированы между
                                собой и&nbsp;разные направления компании &laquo;Росгосстрах&raquo;
                                (РГС) работали в&nbsp;разных подсистемах (экранных формах).
                            </div>
                            <div className="rgs-solutionDescription">
                                Вместо модернизации старой ИТ-системы Клиент принял стратегическое
                                решение разработать новую на&nbsp;микросервисной архитектуре, чтобы
                                обеспечить масштабируемость и&nbsp;возможность быстрой адаптации под
                                новые бизнес-требования.
                            </div>
                        </div>
                        <div className="rgs-solutionRight">
                            Теперь создан новый личный кабинет продавца в&nbsp;едином омниканальном
                            фронтовом решении, куда вошли два продукта&nbsp;&mdash; КАСКО
                            и&nbsp;ОСАГО.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
